"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var pages_navigation_html_1 = __importDefault(require("@public-templates/pages-navigation.html"));
angular.module('reporting.dashboards').directive('pagesNavigation', [
    'pageSearch',
    function (getFilteredPages) {
        return {
            restrict: 'A',
            scope: {
                pages: '=',
                currentPage: '=',
                breakout: '=',
                selectedPage: '=',
                jumpToPage: '=',
                goToPage: '&'
            },
            templateUrl: pages_navigation_html_1.default,
            link: function ($scope) {
                $scope.searchText = '';
                var prevScrollTop = 0;
                var navigationMenu = $('.sidebar-section');
                // On workspace scroll, scroll the navigation menu too!!
                $scope.$watch('selectedPage', function () {
                    if ($scope.jumpToPage) {
                        $scope.jumpToPage = false;
                        return;
                    }
                    function getScrollDirection() {
                        var container = $('body');
                        var direction;
                        if (container.scrollTop() > prevScrollTop) {
                            direction = 'down';
                        }
                        else {
                            direction = 'up';
                        }
                        prevScrollTop = container.scrollTop();
                        return direction;
                    }
                    function hasScrollContent(direction) {
                        if (direction === 'down') {
                            return (navigationMenu[0].scrollHeight - navigationMenu.scrollTop() !== navigationMenu.outerHeight());
                        }
                        else {
                            return !!navigationMenu.scrollTop();
                        }
                    }
                    var direction = getScrollDirection();
                    var highLighted = $('.selected');
                    var highLightedTop = highLighted.length ? highLighted[0].getBoundingClientRect().top : 0;
                    var windowHeight = $(window).height();
                    var scrollDownEvalHeight = windowHeight - windowHeight / 4;
                    var scrollUpEvalHeight = windowHeight / 4;
                    if (hasScrollContent(direction)) {
                        if (direction === 'down' && (highLightedTop > scrollDownEvalHeight)) {
                            navigationMenu.animate({ scrollTop: navigationMenu.scrollTop() + windowHeight - 150 }, 200);
                        }
                        else if (direction === 'up' && (highLightedTop < scrollUpEvalHeight)) {
                            navigationMenu.animate({ scrollTop: navigationMenu.scrollTop() - 200 }, 200);
                        }
                    }
                });
                $scope.filteredPages = $scope.pages.worksheets;
                $scope.filteredQuestionPages = $scope.pages.questionPages;
                $scope.$watch('searchText', _.debounce(function (searchString) {
                    $scope.$apply(function () {
                        $scope.filteredPages = getFilteredPages($scope.pages.worksheets, searchString);
                        $scope.filteredQuestionPages = getFilteredPages($scope.pages.questionPages, searchString);
                    });
                }, 500));
            }
        };
    }
]);
